import type React from "react";
import { Stack } from "~/components/Stack/Stack";
import { Button } from "../Button/Button";
import { Form } from "../Form/Form";
import { Text } from "../Text/Text";
import { TextField } from "../TextField/TextField";

export interface VoucherCodeFormProps {
  voucherCode: string;
  isPending?: boolean;
  onCodeChange: (voucherCode: string) => void;
  onSubmit: (voucherCode: string) => void;
  hideTitle?: boolean;
}

export default function VoucherCodeForm({
  voucherCode,
  isPending = false,
  onCodeChange,
  onSubmit,
  hideTitle = false,
}: VoucherCodeFormProps): React.ReactNode {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (isPending) return;

    const formData = new FormData(event.currentTarget);
    const code = formData.get("code");

    if (typeof code === "string") {
      onSubmit(code);
    }
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Stack space="8">
        {!hideTitle && (
          <Text font="accent" size="large" weight="strong">
            Promo Code
          </Text>
        )}
        <TextField
          name="code"
          value={voucherCode}
          autoComplete="off"
          required
          disabled={isPending}
          onChange={(value) => onCodeChange(value)}
        />
        <Button type="submit" primary disabled={isPending}>
          {isPending ? "Applying..." : "Apply"}
        </Button>
      </Stack>
    </Form>
  );
}
